export type WorkflowBadgeVariant = "default" | "destructive" | "secondary"

export interface WorkflowDisplayFields {
  authority?: string
  v2State?: string | null
  label?: string
  readUnavailable?: boolean
}

export function workflowBadge(fields: WorkflowDisplayFields | undefined, legacyStatus: number) {
  // New metadata is additive. If an old API response omitted any part of it, do not use the
  // compatibility byte as a guessed authority; render the same safe fallback as the C# DTO.
  const metadataComplete = fields?.authority !== undefined && fields.label !== undefined && fields.readUnavailable !== undefined
  const unavailable = !metadataComplete || fields?.readUnavailable === true
  const label = unavailable
    ? "Workflow unavailable"
    : fields?.label ?? "Workflow unavailable"
  const certified = !unavailable && (fields.v2State === "Certified" ||
    (fields.authority === "LegacyCompatibility" && label.endsWith("Certified")))
  const terminal = !unavailable && (fields.v2State === "Aborted" || fields.v2State === "Denied" || fields.v2State === "Cancelled" ||
    (fields.authority === "LegacyCompatibility" && (label.endsWith("Inactive") || label.endsWith("Denied"))))

  return {
    label,
    variant: unavailable || terminal ? "destructive" : certified ? "default" : "secondary",
  } satisfies { label: string; variant: WorkflowBadgeVariant }
}

export function queueTotalPages(totalCount: number, pageSize: number): number {
  return Math.max(1, Math.ceil(Math.max(0, totalCount) / pageSize))
}

export function isCurrentQueueRequest(requestId: number, latestRequestId: number): boolean {
  return requestId === latestRequestId
}
